import { PsHttpService, type PatSnapCommonResponseData } from '@patsnap/tahiti-core/common/ps-http'
import { injectable } from '@patsnap/tahiti-core/shared/inversify'
import type { SignatureApi } from '../signature-api'
import { isUserLogin } from '@eureka/utils/account';

@injectable()
export class SignatureApiImpl extends PsHttpService implements SignatureApi {
    get baseUrl() {
        return `${import.meta.env.VITE_EUREKA_SERVICE_URI}/core-eurekals-api/eurekals_agent/1.0`
    }

    get options() {
        return {
            baseURL: this.baseUrl,
        };
    }

    private async _getBaseUrl(path: string) {
        const isLogin = await isUserLogin()
        const base = isLogin ? '' : '/public'
        return `${base}${path}`
    }

    async getSignaturedPath(params: { sign_type: string; object_key: string[] }) {
        return this.post<PatSnapCommonResponseData<Record<string, string>>>({
            url: await this._getBaseUrl('/signature/sign'),
            data: params,
        }).then(res => res as unknown as Record<string, string>)
    }
}
